import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

const CATEGORIES = [
  { name: "Engine Parts",   image: `${BASE}/api/static/homepage/cat_engine.png`,       href: "/parts?category=engine",       testid: "cat-engine" },
  { name: "Suspension",     image: `${BASE}/api/static/homepage/cat_suspension.png`,   href: "/parts?category=suspension",   testid: "cat-suspension" },
  { name: "Brakes",         image: `${BASE}/api/static/homepage/cat_brakes.png`,       href: "/parts?category=brakes",       testid: "cat-brakes" },
  { name: "Body Panels",    image: `${BASE}/api/static/homepage/cat_bodypanels.png`,   href: "/parts?category=body",         testid: "cat-body" },
  { name: "Electrical Parts", image: `${BASE}/api/static/homepage/cat_electrical.png`, href: "/parts?category=electrical",   testid: "cat-electrical" },
  { name: "Lighting",       image: `${BASE}/api/static/homepage/cat_lighting.png`,     href: "/parts?category=lighting",     testid: "cat-lighting" },
  { name: "Wheels & Tyres", image: `${BASE}/api/static/homepage/cat_wheels_tyres.png`, href: "/parts?category=wheels-tyres", testid: "cat-wheels" },
];

/**
 * "Featured Categories" section — dark strip with a 7-tile category grid, per
 * the reference mockup. Placeholder AI imagery for each tile; will be swapped
 * with real product hero shots once parts are catalogued.
 */
const HomeCategories = () => (
  <section className="vd-featured-cats" data-testid="home-categories">
    <div className="vd-container">
      <div className="text-center mb-10">
        <h2 className="vd-cats-heading">
          FEATURED <span className="vd-red">CATEGORIES</span>
        </h2>
        <span className="vd-red-underline" aria-hidden="true" />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
        {CATEGORIES.map((c) => (
          <Link to={c.href} key={c.name} className="vd-cat-tile" data-testid={c.testid}>
            <div className="vd-cat-tile-img">
              <img src={c.image} alt={c.name} loading="lazy" />
            </div>
            <div className="vd-cat-tile-label">{c.name.toUpperCase()}</div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-8">
        <Link to="/parts" className="vd-btn-primary inline-flex items-center gap-2" data-testid="view-all-categories">
          VIEW ALL CATEGORIES <ArrowRight size={16} />
        </Link>
      </div>
    </div>

    <style>{`
      .vd-featured-cats { background: #0d0d0d; color: #fff; padding: 72px 0; }
      .vd-cats-heading { font-size: clamp(26px, 3.6vw, 38px); font-weight: 900; letter-spacing: 0.06em; margin: 0; color: #fff; }
      .vd-cats-heading .vd-red { color: var(--primary-red); }
      .vd-featured-cats .vd-red-underline { display: inline-block; width: 90px; height: 3px; background: var(--primary-red); border-radius: 2px; margin-top: 8px; }
      .vd-cat-tile {
        display: block; position: relative; overflow: hidden; border-radius: 6px;
        aspect-ratio: 1 / 1; background: #1a1a1a; border: 1px solid rgba(255,255,255,0.08);
        transition: transform 200ms ease, border-color 200ms ease;
      }
      .vd-cat-tile:hover { transform: translateY(-4px); border-color: var(--primary-red); }
      .vd-cat-tile-img { position: absolute; inset: 0; }
      .vd-cat-tile-img img { width: 100%; height: 100%; object-fit: cover; transition: transform 400ms ease; }
      .vd-cat-tile:hover .vd-cat-tile-img img { transform: scale(1.06); }
      .vd-cat-tile-label {
        position: absolute; left: 0; right: 0; bottom: 0; text-align: center;
        background: var(--primary-red); color: #fff; font-weight: 800; font-size: 11px;
        letter-spacing: 0.06em; padding: 8px 6px; text-transform: uppercase;
      }
    `}</style>
  </section>
);

export default HomeCategories;
